<template>
    <div>
        <template>
            <div v-if="!lines.length">
                Your basket is empty
            </div>
            <div class="row basket-row" v-for="(line, index) in lines" :key="line.id">
                <div class="col-xs-5 col-sm-1 basket-row__column">
                    <a :href="url(line.variant)" class="basket-product-img">
                        <img :src="thumb(line.variant)" style="width:100%;" alt="#">
                    </a>
                </div>
                <div class="col-xs-7 col-sm-4 basket-row__column">
                    <a :href="url(line.variant)" class="basket-product-title">
                        {{ line.variant.product.name }}
                    </a>
                    <p class="sku">SKU Number: <strong v-text="line.variant.sku"></strong></p>
                    <div class="text-warning" v-if="line.variant.inventory <= line.quantity">
                        We only have {{ line.variant.inventory }} in stock, but you can still proceed.
                    </div>
                    <div class="basket-row__stock" v-else>
                        {{ line.variant.inventory }} in stock
                    </div>
                    <template v-for="error in getErrors(index)">
                        <span class="text-danger">{{ error }}</span> <br>
                    </template>

                    <template v-for="error in getErrors(index + '.quantity')">
                        <span class="text-danger">{{ error }}</span><br>
                    </template>
                </div>
                <div class="col-sm-2 hidden-xs basket-row__column">
                    <div class="product-price basket-row__price">
                        <product-price :price="line.unit_price" :tax="line.unit_tax"></product-price>
                    </div>
                </div>
                <div class="clearfix visible-xs-block"></div>
                <div class="col-xs-5 col-sm-2 basket-row__column">
                    <input type="number" class="form-control form-control--basket-quantity" v-model="line.quantity" @keyup="update(index)" @change="update(index)">
                    <template v-if="updating == index">
                        <small class="text-info"><i class="fa fa-refresh fa-spin"></i></small>
                    </template>
                </div>
                <div class="col-xs-7 col-sm-2 basket-row__column">
                    <div class="product-price basket-row__price basket-row__price--line-price">
                        <product-price :price="line.line_total" :tax="line.tax"></product-price>
                        <small v-if="line.variant.product.additionaldelivery > 0">
                            Plus &pound;{{ (line.variant.product.additionaldelivery * line.quantity)|number_format }} ex. VAT delivery
                        </small>
                    </div>
                </div>
                <div class="clearfix visible-xs-block"></div>
                <div class="col-xs-12 col-sm-1 text-right basket-row__column">
                    <a @click="remove(index)" class="basket-row__delete">
                        <span class="basket-row__delete--icon">
                            <i class="fa fa-times-circle" aria-hidden="true"></i>
                        </span>
                        <span class="basket-row__delete--text">
                            Remove
                        </span>
                    </a>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import BasketService from '../../Services/Basket.js';
    import Loader from '../Elements/Loading.vue';
    import ProductPrice from '../Product/ProductPrice.vue';

    export default {
        components: {
            Loader,
            ProductPrice
        },
        data() {
            return {
                service: BasketService,
                errors: [],
                updating: null
            }
        },

        methods: {
            url(model, isProduct) {
                let slug;
                if (isProduct) {
                    slug = model.routes[0].slug;
                } else {
                    slug = model.product.routes[0].slug;
                }
                return '/products/' + slug;
            },
            thumb(variant) {
                var primary = _.find(variant.product.assets, asset => {
                    return asset.primary;
                });
                if (!primary) {
                    return '/img/orbital/products/placeholder.png';
                }
                return primary.transforms[0].url;
            },
            update: _.debounce(function(index) {
                this.errors = [];
                this.updating = index;

                // Set the backorder meta
                _.each(this.lines, line => {
                    if (line.variant.inventory < line.quantity) {
                        line.meta = {
                            backorder: true,
                        };
                    } else {
                        line.meta = null;
                    }
                });
                this.service.setLines(this.lines).then(response => {
                  this.updating = null;
                }).catch(errors => {
                  this.updating = null;
                  this.errors = this.service.errors;
                });
            }, 500),
            remove(index) {
                this.lines.splice(index, 1);
                this.service.setLines(this.lines).then(response => {
                    if (!this.lines.length) {
                        location.reload();
                    }
                });
            },
            getErrors(index) {
                if (this.errors['variants.' + index]) {
                    return this.errors['variants.' + index];
                }
                return [];
            }
        },
        computed: {
            lines() {
                return this.service.basket.lines;
            },
            fetching() {
                return this.service.fetching;
            },
            discounts() {
                return this.service.basket.discounts;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form-control--basket-quantity {
        display:inline-block;
        margin-right:15px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/Components/Basket/BasketLines.vue